import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Layout } from 'antd'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import Home from './pages/Home/Home'
import About from './pages/About/About'
import Contact from './pages/Contact/Contact'
import './index.scss'

const { Content } = Layout

function App() {
  return (
    <Router>
      <Layout className='layout'>
        {/* 头部组件（全局） */}
        <Header />
        {/* 内容区域（路由匹配） */}
        <Content className='page-container'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
          </Routes>
        </Content>
        {/* 尾部组件（全局） */}
        <Footer />
      </Layout>
    </Router>
  )
}

export default App
